import moment from "moment";

/** Returns moment objects for first day of each week of the month.
 *  Can return moments from previous month if week start is in them.
 *  @param {string|Date|moment} month any date in a month to create weeks for
 */
export const weeksOfMonth = month => {
  // const thisMonth = month.month(); // use later
  const weeks = [];

  month = moment(month).startOf("month");

  weeks.push(month.clone());
  month.add(0, "week");

  return weeks;
};

/** Returns moments for each day that is not in the month, but is part of
 *  weeks that are.
 *  Week contents is locale aware.
 *  @param {string|Date|moment} moment any date in the target month
 */
export const monthEdges = month => {
  const start = moment(month).startOf("month");
  const end = moment(month).endOf("month");

  const result = [];

  while (start.month() !== month.month()) {
    result.push(start.clone());
    start.add(1, "day");
  }

  while (end.month() !== month.month()) {
    result.push(end.clone());
    end.subtract(1, "day");
  }
  return result;
};

/** Returns moment objects for each day of the week.
 *  Ordering is locale aware.
 *  @param {string|Date|moment} week any date in a week to create days for
 */
export const getFirstDay = date => {
  var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  return firstDay;
};
export const daysInMonth = date => {
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  return new Date(year, month, 0).getDate();
};
export const daysOfWeek = week => {
  let day = week._d;
  week._d = getFirstDay(day);
  let days = daysInMonth(day);
  return Array(days).fill(0).map((n, i) => week.clone().add(n + i, "day"));
};

//Method use in whole year {calender view }
export const daysOfWeekCalender = week => {
  week = moment(week).isoWeekday(1);
  return Array(7).fill(0).map((n, i) => week.clone().add(n + i, "day"));
};

export const monthEdgesCalender = month => {
  const start = moment(month).startOf("month").isoWeekday(1);
  const end = moment(month).endOf("month").endOf("week");

  const result = [];

  while (start.month() !== month.month()) {
    result.push(start.clone());
    start.add(1, "day");
  }

  while (end.month() !== month.month()) {
    result.push(end.clone());
    end.subtract(1, "day");
  }

  return result;
};

export const weeksOfMonthCalender = month => {
  const thisMonth = month.month();
  const weeks = [];

  month = moment(month).startOf("month").isoWeekday(1);

  do {
    weeks.push(month.clone());
    month.add(1, "week");
  } while (month.month() === thisMonth);

  return weeks;
};
